import { Button, Dialog, Icon } from './ui';
import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

export default function DirPicker({ value, onSelect, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = async (path) => {
    setLoading(true);
    setError(null);
    try { setData(await api.browseDir(path)); }
    catch (e) { setError(e?.response?.data?.detail || 'Не удалось открыть папку'); }
    finally { setLoading(false); }
  };
  useEffect(() => { navigate(value || null); }, [value]);

  return <Dialog title="Выбор рабочей папки" onClose={onClose}>
    <div className="flex gap-2" style={{ alignItems: 'center' }}>
      {data?.parent != null && <Button aria-label="На уровень выше" disabled={loading} onClick={() => navigate(data.parent)}><Icon name="back" /></Button>}
      <code className="directory-path">{data?.current || 'Загрузка…'}</code>
    </div>
    {error && <div className="alert alert-error mt-2" role="alert">{error}</div>}
    <div className="directory-list" aria-busy={loading}>
      {loading ? <div className="loading" role="status">Открываем папку…</div>
        : data?.entries.map(entry => <button type="button" key={entry.path} className="directory-entry" onClick={() => navigate(entry.path)}>
          <Icon name="folder" /><span>{entry.name}</span><Icon name="chevron" size={16} />
        </button>)}
      {!loading && !error && data?.entries.length === 0 && <div className="empty">Папка пуста. Её можно выбрать как рабочую.</div>}
    </div>
    <div className="dialog-actions"><Button onClick={onClose}>Отмена</Button>
      <Button variant="primary" disabled={loading || !data?.current || !!error} onClick={() => { onSelect(data.current); onClose(); }}>Выбрать эту папку</Button>
    </div>
  </Dialog>;
}
